export default __webpack_public_path__ + "static/media/deactivate-blog-icon.cba0da25.svg";